import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import AgentsPage from './views/Agents';
import DataLogsPage from './views/DataLogs';
import MembersPage from './views/Members';
import MetricsPage from './views/Metrics';
import StoresPage from './views/Stores';

export const settingsRoutes = [
  {
    path: 'settings',
    name: '系统设置',
    icon: 'setting',
    children: [
      {
        index: true,
        element: <Navigate to="members" replace />,
      },
      {
        path: 'members',
        name: '成员管理',
        icon: 'team',
        element: <MembersPage />,
      },
      {
        path: 'metrics',
        name: '指标管理',
        icon: 'fund',
        element: <MetricsPage />,
      },
      {
        path: 'operation-entities',
        element: <Navigate to="../stores?tab=operation-entities" relative="path" replace />,
      },
      {
        path: 'stores',
        name: '门店管理',
        icon: 'shop',
        element: <StoresPage />,
      },
      {
        path: 'logs',
        name: '数据日志',
        icon: 'profile',
        element: <DataLogsPage />,
      },
      {
        path: 'agents',
        name: '智能体管理',
        icon: 'robot',
        element: <AgentsPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
